var React = require('react');

function BlobOne (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(300,300)"},React.createElement("path",{"d":"M120.8,-214.4C140.6,-175.2,129.9,-114.8,152.7,-68.6C175.5,-22.5,231.7,9.5,249.2,50.8C266.6,92.2,245.1,143,206.1,166.7C167.1,190.3,110.4,186.8,67.5,173.7C24.6,160.6,-4.6,137.8,-34.2,125.2C-63.9,112.6,-93.9,110,-130.7,96.9C-167.4,83.8,-210.9,60.2,-225.7,26.1C-240.5,-8,-226.7,-52.6,-198.3,-80.4C-169.8,-108.3,-126.8,-119.3,-91.3,-151.5C-55.9,-183.6,-27.9,-236.8,11.3,-254.3C50.5,-271.9,100.9,-253.7,120.8,-214.4Z","fill":"currentColor"})));
}

BlobOne.defaultProps = {"width":"600","height":"600","viewBox":"0 0 600 600"};

module.exports = BlobOne;

BlobOne.default = BlobOne;
